module.exports = __webpack_public_path__ + "static/media/effect-04.41e5f80a.gif";